import { useNavigate } from "@tanstack/react-router";
import { useCallback } from "react";

import { AuthFlow } from "~/components/auth/auth-flow";
import { Card } from "~/components/ui/card";
import ImageLogoHorizontal from "~/img/logo/dcm-horizontal-1.png";

interface AuthModalProps {
  isModalView?: boolean;
  onSuccess?: () => void;
  initialEmail?: string;
}

export const AuthModal = ({
  onSuccess,
  isModalView = false,
  initialEmail,
}: AuthModalProps) => {
  const navigate = useNavigate();

  const handleSuccess = useCallback(() => {
    if (onSuccess) {
      onSuccess();
    } else {
      navigate({ to: "/discovery/steps/processing" });
    }
  }, [navigate, onSuccess]);

  const content = (
    <AuthFlow
      defaultEmail={initialEmail}
      onSuccess={handleSuccess}
      redirectUrl={
        typeof window !== "undefined" ? window.location.href : "/dashboard"
      }
    />
  );

  return (
    <div
      className={`flex flex-col items-center justify-center gap-6 ${isModalView ? "p-6" : ""}`}
    >
      <img
        src={ImageLogoHorizontal}
        alt="Dream Coach Match"
        className="w-[203px]"
      />
      {isModalView ? (
        <div className="flex w-full flex-col">{content}</div>
      ) : (
        <Card className="flex w-full max-w-[480px] flex-col p-6 hover:shadow">
          {content}
        </Card>
      )}
    </div>
  );
};
